import { render } from "./TeacherAssignTypingPractice.vue?vue&type=template&id=1ea0f936&scoped=true"
import script from "./TeacherAssignTypingPractice.vue?vue&type=script&lang=js"
export * from "./TeacherAssignTypingPractice.vue?vue&type=script&lang=js"

import "./TeacherAssignTypingPractice.vue?vue&type=style&index=0&id=1ea0f936&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea0f936"]])

export default __exports__